var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Snackbar',{attrs:{"data-test":"snackbar-component"}}),_c(_vm.layout,{tag:"component",attrs:{"data-test":_vm.layout+'-component'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }